import { useState } from "react";
import { createId } from "@corpuscomplete/core/utils";
import type { MealPlan } from "@corpuscomplete/core/nutrition/meal-plan";
import { MealPlanDetail } from "@corpuscomplete/core-ui/nutrition/meal-plan/detail";
import { Button } from "@corpuscomplete/web-ui/components/button";
import { Input } from "@corpuscomplete/web-ui/components/input";
import { PopoverContent } from "@corpuscomplete/web-ui/components/popover";
import { Text } from "@corpuscomplete/web-ui/components/text";

export function OccurrenceEditorPopoverContent({
  onOpenChange,
  mealId,
  occurrences,
}: {
  onOpenChange: (open: boolean) => void;
  mealId: string;
  occurrences: readonly MealPlan.MealOccurrence[];
}) {
  const [newDate, setNewDate] = useState("");
  const { addMealOccurrence, editMealOccurrence, removeMealOccurrence } =
    MealPlanDetail.useMutations();

  return (
    <PopoverContent align="start" className="w-80 p-3">
      <div className="flex max-h-[55vh] flex-col gap-2 overflow-y-auto">
        {occurrences.map((occurrence) => (
          <div
            key={occurrence.id}
            className="flex items-center gap-2 rounded-md border border-border/60 bg-muted/5 px-2 py-1.5"
          >
            <Input
              type="date"
              value={toDateInput(occurrence.date)}
              onChange={(event) =>
                editMealOccurrence(mealId, occurrence.id, {
                  date:
                    event.target.value === "" ? null : Temporal.PlainDate.from(event.target.value),
                })
              }
            />
            <Button
              variant="ghost"
              size="sm"
              className="text-muted-foreground"
              onClick={() => removeMealOccurrence(mealId, occurrence.id)}
            >
              <Text variant="xs">Remove</Text>
            </Button>
          </div>
        ))}
      </div>
      <div className="flex flex-col gap-2 sm:flex-row sm:items-center sm:justify-between">
        <div className="flex items-center gap-2">
          <Input type="date" value={newDate} onChange={(event) => setNewDate(event.target.value)} />
          <Button
            variant="outline"
            className="bg-background"
            onClick={() => {
              addMealOccurrence(mealId, {
                id: createId(),
                date: newDate ? Temporal.PlainDate.from(newDate) : null,
              });
              setNewDate("");
            }}
          >
            <Text variant="xs">Add</Text>
          </Button>
        </div>
        <Button variant="outline" onClick={() => onOpenChange(false)}>
          <Text variant="xs">Done</Text>
        </Button>
      </div>
    </PopoverContent>
  );
}

function toDateInput(value: Temporal.PlainDate | null): string {
  if (value === null) {
    return "";
  }
  return value.toString();
}
